<template>
	<header
		class="container-inset sticky top-0 inset-x-0 bg-white h-[4.3rem] lg:h-20 flex items-center z-30 shadow-[0_2px_4px_0_rgba(0,0,0,0.08)]"
	>
		<div class="container flex justify-between items-center w-full">
			<button
				type="button"
				:class="{'invisible opacity-0': !navStore.hasPreviousStep}"
				class="flex justify-start items-center w-10 h-10 opacity-100 transition-opacity duration-200 lg:hidden"
				@click="navStore.gotoPreviousStep()"
			>
				<ArrowIcon class="size-6 pointer-events-none" />
			</button>

			<a :href="config.websiteUrl" class="block" :title="t('go_to_the_website')" @click="handleGoToWebsiteClick">
				<span class="w-12 h-12 lg:w-auto relative overflow-hidden block">
					<ResortLogo class="h-12" />
				</span>
			</a>

			<button
				type="button"
				:title="t('go_to_the_website')"
				:class="{'invisible': !bridge.isIntergrated && !readOnlyMode}"
				class="flex justify-end items-center w-10 h-10"
				@click="handleGoToWebsiteClick"
			>
				<CrossIcon class="size-4 pointer-events-none" />
			</button>
		</div>
	</header>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import config from '@/config';
import bridge from '@thermenresorts/bridge';
import { useNavigationStore } from '@/stores/useNavigationStore';
import ArrowIcon from '@thermenresorts/icons/svg/arrow-left.svg';
import CrossIcon from '@thermenresorts/icons/svg/cross.svg';
import ResortLogo from '@/components/ResortLogo.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const route = useRoute();
const navStore = useNavigationStore();
const readOnlyMode = computed(() => route.query.ro === 'true');

const handleGoToWebsiteClick = (event: MouseEvent) => {
  if (event) event.preventDefault();
  const isReactNative = !!(window.ReactNativeWebView && window.ReactNativeWebView.postMessage);

  bridge.sendMessage('reservation-flow', 'reservation-flow.close');

  if (bridge.isIntergrated && !isReactNative) {
    window.setTimeout(() => {
      window.location.replace(window.location.pathname);
    }, 0);
  }

  if (isReactNative) {
    window.ReactNativeWebView.postMessage('reservation-flow.close');
    return;
  }

  if (!bridge.isIntergrated) window.location.href = config.websiteUrl;
};
</script>
